import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import "../src/styles/style.css";
import './App.css';
import Add from './Component/Add/Add';
import Edit from './Component/Edit/Edit';
import Books from './Component/Header/Books/Books';
import Header from './Component/Header/Header';

function App() {
  return (
    <BrowserRouter>
    <Header></Header>
    <Routes>
      <Route path='/' element={<Books></Books>}></Route>
      <Route path='/add' element={<Add></Add>}></Route>
      <Route path='/edit/:bookId' element={<Edit></Edit>}></Route>
    </Routes>
    </BrowserRouter>
  );
}

export default App;
